import { cvssStringColorMap } from '@/data/cvssStringColors.ts';

/** Dependabot's 'moderate' and Trivy's 'medium' are the same tier under two vocabularies, so both map to the same color/rank here (reusing the app-wide `cvssStringColorMap`). */
export const DEPENDENCY_SEVERITY_COLOR: Record<string, string> = {
  critical: cvssStringColorMap.critical,
  high: cvssStringColorMap.high,
  medium: cvssStringColorMap.medium,
  moderate: cvssStringColorMap.medium,
  low: cvssStringColorMap.low,
};

/** Rank for sorting most-severe-first; lower is more severe. */
export const DEPENDENCY_SEVERITY_RANK: Record<string, number> = {
  critical: 0,
  high: 1,
  medium: 2,
  moderate: 2,
  low: 3,
};

/** Matches a machine-parseable CVE identifier (e.g. `CVE-2026-12345`). */
export const CVE_ID_PATTERN = /^CVE-\d{4}-\d+$/i;
